'use strict';

let module = {};

(function (module) {

    var routes = function ($stateProvider, baseState) {

        $stateProvider

            .state('' + baseState + '.clerk-fiscal-years', {
                abstract: true,
                url: "/fiscal-years",
                template: "<ui-view/>"
            })

            ;

        var views = {};
        views['@' + baseState + '.clerk-fiscal-years'] = {
            template: require("crud/clerk-fiscal-year/list.html"),
            controller: "listClerkFiscalYearsController",
        };

        $stateProvider

            .state('' + baseState + '.clerk-fiscal-years.list', {
                url: "/list",
                views: views,
                data: {pageTitle: 'List Fiscal Years'}
            })

            ;

        var views = {};
        views['@' + baseState + '.clerk-fiscal-years'] = {
            template: "<ui-view/>",
            controller: "listClerkFiscalYearsController",
        };

        $stateProvider

            .state('' + baseState + '.clerk-fiscal-years.curate', {
                abstract: true,
                url: "/curate",
                views: views,
                data: {pageTitle: 'Curate Fiscal Years'}
            })

            // Add initial alias for "first-step" TODO: Refactor to have dynamic step logic in angular logic instead of repeated code
            .state('' + baseState + '.clerk-fiscal-years.curate.continue-editing', {
                url: "/continue-editing",
                data: {
                    pageTitle: 'Curate Fiscal Year - Step \'edit-fiscal-year\'',
                    stepCaption: "Edit Fiscal Year",
                    stepMetadata: {"stepReference":"edit-fiscal-year","step":"edit-fiscal-year"},
                },
                template: require("crud/clerk-fiscal-year/curate-steps/edit-fiscal-year.html"),
                controller: "listClerkFiscalYearsController",
                resolve: {
                    setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                        routeBasedVisibilitySettings.ClerkFiscalYear_columns_by_step = 'edit-fiscal-year';
                    },
                }
            })

            // "Edit Fiscal Year"
            .state('' + baseState + '.clerk-fiscal-years.curate.edit-fiscal-year', {
                url: "/edit-fiscal-year",
                data: {
                    pageTitle: 'Curate Fiscal Year - Step \'edit-fiscal-year\'',
                    stepCaption: "Edit Fiscal Year",
                    stepMetadata: {"stepReference":"edit-fiscal-year","step":"edit-fiscal-year"},
                },
                template: require("crud/clerk-fiscal-year/curate-steps/edit-fiscal-year.html"),
                controller: "listClerkFiscalYearsController",
                resolve: {
                    setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                        routeBasedVisibilitySettings.ClerkFiscalYear_columns_by_step = 'edit-fiscal-year';
                    },
                }
            })

            // "Review & Approve"
            .state('' + baseState + '.clerk-fiscal-years.curate.review-and-approve', {
                url: "/review-and-approve",
                data: {
                    pageTitle: 'Curate Fiscal Year - Step \'review-and-approve\'',
                    stepCaption: "Review & Approve",
                    stepMetadata: {"stepReference":"review-and-approve","step":"review-and-approve"},
                },
                template: require("crud/clerk-fiscal-year/curate-steps/review-and-approve.html"),
                controller: "listClerkFiscalYearsController",
                resolve: {
                    setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                        routeBasedVisibilitySettings.ClerkFiscalYear_columns_by_step = 'review-and-approve';
                    },
                }
            })


            .state('' + baseState + '.clerk-fiscal-years.create', {
                url: "/new",
                onEnter: /*@ngInject*/ function ($state, clerkFiscalYear, clerkFiscalYears) {
                    let itemAttributes = {
                        'attributes': {
                        }
                    };
                    clerkFiscalYears.add(itemAttributes, function (createdItem) {
                        let goToStateParams = angular.merge($state.params, {activeClerkFiscalYearId: createdItem.id});
                        $state.transitionTo(
                            '' + baseState + '.clerk-fiscal-years.existing.edit.continue-editing',
                            goToStateParams,
                            {location: 'replace', inherit: true, relative: $state.$current, notify: true}
                        );
                    });
                },
                data: {pageTitle: 'New Fiscal Year'}
            })

            .state('' + baseState + '.clerk-fiscal-years.existing', {
                abstract: true,
                url: "/:activeClerkFiscalYearId",
                resolve: {
                    setRouteBasedContentFiltersLevel0: /*@ngInject*/ function (routeBasedContentFilters, $stateParams) {
                        // TODO: Generate the following dynamically based on data model
                        routeBasedContentFilters.Bar_order = 'Foo.id DESC';
                        routeBasedContentFilters.Bar_foo_id = $stateParams.fooId;
                    },
                    setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                        // TODO: Adjust the below so that columns that are all the same value due to a route-based filter are hidden
                        routeBasedVisibilitySettings.ClerkFiscalYear_hide_source_relation = 'ClerkFiscalYear';
                    },
                    currentClerkFiscalYear: /*@ngInject*/ function ($stateParams, clerkFiscalYear) {
                        let activeClerkFiscalYearId = $stateParams.activeClerkFiscalYearId;
                        clerkFiscalYear.$activate();
                        return clerkFiscalYear.load(activeClerkFiscalYearId);
                    },
                },
                template: "<ui-view/>"
            })

            /*
             .state('' + baseState + '.clerk-fiscal-years', {
             url: "/dashboard",
             template: require("crud/clerk-fiscal-year/dashboard.html"),
             data: {pageTitle: 'Fiscal Years Dashboard'}
             })
             */

            ;

        var views = {};
        views['@' + baseState + '.clerk-fiscal-years'] = {
            controller: "editClerkFiscalYearController",
            template: require("crud/clerk-fiscal-year/view.html"),
        };

        $stateProvider

            .state('' + baseState + '.clerk-fiscal-years.existing.view', {
                url: "/view",
                views: views,
                data: {pageTitle: 'View Fiscal Year'}
            })


            ;

        var views = {};
        views['@' + baseState + '.clerk-fiscal-years'] = {
            controller: "editClerkFiscalYearController",
            template: require("crud/clerk-fiscal-year/components/form.html")
        };
        /*
        views['sidebar@root'] = {
            template: require("crud/clerk-fiscal-year/navigation.html")
        };
        */

        $stateProvider

            .state('' + baseState + '.clerk-fiscal-years.existing.edit', {
                abstract: true,
                url: "/edit",
                views: views,
                data: {
                    showSideMenu: true,
                    pageTitle: 'Edit Fiscal Year'
                }
            })

            // Add initial alias for "first-step" TODO: Refactor to have dynamic step logic in angular logic
            .state('' + baseState + '.clerk-fiscal-years.existing.edit.continue-editing', {
                url: "/continue-editing",
                template: require("crud/clerk-fiscal-year/steps/edit-fiscal-year.html"),
                data: {pageTitle: 'Edit Fiscal Year'}
            })

            // "Edit Fiscal Year"
            .state('' + baseState + '.clerk-fiscal-years.existing.edit.edit-fiscal-year', {
                url: "/edit-fiscal-year",
                template: require("crud/clerk-fiscal-year/steps/edit-fiscal-year.html"),
                data: {
                    pageTitle: 'Edit Fiscal Year - Step \'edit-fiscal-year\'',
                    stepCaption: "Edit Fiscal Year",
                    stepMetadata: {"stepReference":"edit-fiscal-year","step":"edit-fiscal-year"},
                }
            })

            .state('' + baseState + '.clerk-fiscal-years.existing.edit.edit-fiscal-year.attributes', {
                abstract: true,
                template: "<ui-view/>"
            })

            // "id" TYPE primary-key TODO scrollto/mark -->

            // "remote_source_tag_spec" TYPE ordinary TODO scrollto/mark -->

            // "clerkTaxEntity" TYPE has-one-relation TODO scrollto/mark -->

            // "label" TYPE ordinary TODO scrollto/mark -->

            // "vatDeclarationReportingBasis" TYPE has-one-relation TODO scrollto/mark -->

            // "payrollTaxDeclarationReportingBasis" TYPE has-one-relation TODO scrollto/mark -->

            // "ecSalesListReportingBasis" TYPE has-one-relation TODO scrollto/mark -->

            // "incomeTaxReturnReportingBasis" TYPE has-one-relation TODO scrollto/mark -->

            // "annualReportReportingBasis" TYPE has-one-relation TODO scrollto/mark -->

            // "start_utc_datetime" TYPE ordinary TODO scrollto/mark -->

            // "end_utc_datetime" TYPE ordinary TODO scrollto/mark -->

            // "is_tax_entitys_first_fiscal_year" TYPE ordinary TODO scrollto/mark -->

            // "previousClerkFiscalYear" TYPE has-one-relation TODO scrollto/mark -->

            // "income_tax_percentage" TYPE ordinary TODO scrollto/mark -->

            // "raw_info_tax_entity_name" TYPE ordinary TODO scrollto/mark -->

            // "raw_info_tax_entity_orgnr" TYPE ordinary TODO scrollto/mark -->

            // "raw_info_weight" TYPE ordinary TODO scrollto/mark -->

            // "key_combo" TYPE ordinary TODO scrollto/mark -->

            // "interpretation" TYPE internal TODO scrollto/mark -->

            // "most_recent_interpretation_of_clue_utc_datetime" TYPE ordinary TODO scrollto/mark -->

            // "created" TYPE ordinary TODO scrollto/mark -->

            // "modified" TYPE ordinary TODO scrollto/mark -->

        /**
         * START ClerkFiscalYear has-many-relation Clerk Fiscal Years Related By Previous Clerk Fiscal Year Id editing functionality in step ' + baseState + '.clerk-fiscal-years.existing.edit.edit-fiscal-year.attributes.edit-fiscal-year
         */
        // Recursion limit reached
        /**
         * END ClerkFiscalYear has-many-relation Clerk Fiscal Years Related By Previous Clerk Fiscal Year Id editing functionality in step ' + baseState + '.clerk-fiscal-years.existing.edit.edit-fiscal-year.attributes.edit-fiscal-year
         */

            // "Review & Approve"
            .state('' + baseState + '.clerk-fiscal-years.existing.edit.review-and-approve', {
                url: "/review-and-approve",
                template: require("crud/clerk-fiscal-year/steps/review-and-approve.html"),
                data: {
                    pageTitle: 'Edit Fiscal Year - Step \'review-and-approve\'',
                    stepCaption: "Review & Approve",
                    stepMetadata: {"stepReference":"review-and-approve","step":"review-and-approve"},
                }
            })

            .state('' + baseState + '.clerk-fiscal-years.existing.edit.review-and-approve.attributes', {
                abstract: true,
                template: "<ui-view/>"
            })

            // "required_to_submit_vat_tax_return_to_tax_agency" TYPE ordinary TODO scrollto/mark -->

            // "vat_tax_return_submitted_to_tax_agency" TYPE ordinary TODO scrollto/mark -->

            // "required_to_submit_income_tax_return_to_tax_agency" TYPE ordinary TODO scrollto/mark -->

            // "income_tax_return_submitted_to_tax_agency" TYPE ordinary TODO scrollto/mark -->

            // "required_to_submit_other_tax_returns_to_tax_agency" TYPE ordinary TODO scrollto/mark -->

            // "other_tax_returns_submitted_to_tax_agency" TYPE ordinary TODO scrollto/mark -->

            // "compliantMinimalLedger" TYPE has-one-relation TODO scrollto/mark -->

            // "betweenEffectAndComplianceBalancedLedger" TYPE has-one-relation TODO scrollto/mark -->

            // "maximalEffectLedger" TYPE has-one-relation TODO scrollto/mark -->

            // "activeLedger" TYPE has-one-relation TODO scrollto/mark -->

            // "reportedLedger" TYPE has-one-relation TODO scrollto/mark -->

            // "alternativeLedger" TYPE has-one-relation TODO scrollto/mark -->

            // "importedLedger" TYPE has-one-relation TODO scrollto/mark -->



        ;

    };

    module.routes = routes;

    /*
     Usage example:
     someAngularModuleThatRequiresThisItemsCrudRouting.config(function ($stateProvider) {
         routes($stateProvider, 'root.api-endpoints.existing');
     });
     */

})(module);

export default module;



// WEBPACK FOOTER //
// .-dna/app/crud/clerk-fiscal-year/routes.js